import { slugify } from "@covertree/utils";
import { Box, Button } from "@mui/material";
import { PersonalizedPlanDetailsType } from "@covertree/new-business-forms";

import { Offer } from "@covertree/new-business-graphql";

interface MobileDetailsModalFooterProps {
  personalizedPlans: PersonalizedPlanDetailsType[];
  onPlanSelect: (offer: Offer) => void;
  onClose: () => void;
}

export function MobileDetailsModalFooter({
  personalizedPlans,
  onPlanSelect,
  onClose,
}: MobileDetailsModalFooterProps) {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        justifyContent: "space-evenly",
        position: "sticky",
        width: "100%",
        overflow: "hidden",
        bottom: 0,
        left: 0,
        mt: 2,
        background: theme.palette.background.paper,
      })}>
      {personalizedPlans.map((personalizedPlan) => (
        <Box
          key={personalizedPlan.title}
          sx={(theme) => ({
            flex: 1,
            maxWidth: "33%",
            padding: theme.spacing(1),
            textAlign: "center",
            ...(personalizedPlan.isRecommended && {
              backgroundColor: `${theme.palette.info.main}0D`,
            }),
          })}>
          <Button
            key={`select_${personalizedPlan.title}`}
            data-testid={`${slugify(personalizedPlan.title)}-select-button`}
            sx={{ maxWidth: "160px" }}
            fullWidth
            size="small"
            color="primary"
            variant={personalizedPlan.isRecommended ? "contained" : "outlined"}
            onClick={() => {
              onPlanSelect(personalizedPlan.offer);
              onClose();
            }}>
            Select
          </Button>
        </Box>
      ))}
    </Box>
  );
}
